// extracted by mini-css-extract-plugin
export default {"wrapper":"ProgressCircle_wrapper__sKyBP","middle-circle":"ProgressCircle_middle-circle__CEzCe","progress":"ProgressCircle_progress__HCedF"};